import { useEffect } from "react";
import { rootComponentsStore } from "../hookstate/rootComponentsStore";
import { useIsTopBarHidden } from "./useIsTopBarHidden";

export enum ScrollDirection {
  Up = "up",
  Down = "down",
}

export const useWindowScroll = (threshold = 100) => {
  useEffect(() => {
    let lastScrollY = window.scrollY;

    const onScroll = () => {
      const currentScrollY = window.scrollY;
      const diff = currentScrollY - lastScrollY;

      if (Math.abs(diff) < threshold) return;

      if (diff > 0) {
        rootComponentsStore.isTopBarHidden.set(true);
      } else {
        rootComponentsStore.isTopBarHidden.set(false);
      }

      lastScrollY = currentScrollY;
    };

    window.addEventListener("scroll", onScroll, { passive: true });

    return () => window.removeEventListener("scroll", onScroll);
  }, []);
};

export const useScrollVisibility = () => {
  const isTopBarHidden = useIsTopBarHidden();

  return {
    isHidden: isTopBarHidden,
  };
};
